import React, { useEffect } from 'react';
import FieldsDropdownNoLazy from '@atlassian/jira-business-list/src/ui/list-view/base-table/fields-dropdown/dropdown/main.tsx';
import type { TableProps } from '../../../common/types/base-table';
import type { ListViewControllerData } from '../../../controllers/list-view-issues/types';
import AsyncTable, { Table } from './async';
import FieldsDropdown, { FieldsDropdownNoLazyWithWrapper } from './fields-dropdown';
import { LoadingTable } from './loading-table';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: TableProps<ListViewControllerData>) => {
	useEffect(() => {
		// preload components required for initial render
		Table.preload();
	}, []);

	return <AsyncTable {...props} />;
};

export { useHighlightDoneItems } from './utils';
export { LoadingTable, FieldsDropdown, FieldsDropdownNoLazy, FieldsDropdownNoLazyWithWrapper };
